module.exports = __webpack_public_path__ + "0ab56d48e357428ad90513d0f1deb41c.jpg";